import React, { useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import { FORM_ERROR_MESSAGES } from "consts/errorMessages";
import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { FormikSelectInput } from "components/UI/Inputs/FormikInputs";
import { FormButton, CircularIndeterminate } from "components";
import { SFHotelEmpleadoUpd } from "services/services-mia/";

export default function UpdateModal({ empleado, roles, updateList, closeModal }) {
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const formikRef = useRef();

    const functions = {
        setSnackbarInfo,
        setInRequest,
        setIsOpen: closeModal,
        updateList,
    };


    const rolesDisponibles = (roles ?? []).filter(role => role.rolCod !== empleado.rolCod);

    const handleSubmit = async (values) => {
        setInRequest(true);
        const response = await SFHotelEmpleadoUpd({
            msuAdicionalId: empleado.id,
            rolCod: values.rolCod,
            msuAdicionalVersion: empleado.msuAdicionalVersion,
        }, credentials);

        handleResponse(
            response,
            "Rol actualizado exitosamente",
            functions
        );

        setInRequest(false);
    };

    const validationSchema = yup.object({
        rolCod: yup.string(FORM_ERROR_MESSAGES.text)
            .required(FORM_ERROR_MESSAGES.required),
    });

    return (
        <Formik
            innerRef={formikRef}
            initialValues={{ rolCod: "" }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    await handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <FormikSelectInput
                        fullWidth={true}
                        name="rolCod"
                        labelText="Rol"
                    >
                        <option value="">Seleccione un rol</option>
                        {(rolesDisponibles ?? []).map(({ rolCod, rolNombre }) => (
                            <option
                                key={rolCod}
                                data-id={rolCod}
                                value={rolCod}
                            >
                                {rolNombre}
                            </option>
                        ))}
                    </FormikSelectInput>

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar cambios" }}
                        onCloseModal={closeModal}
                    />

                    {inRequest && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}